/**
 * Mexican Unidad de Inversion.
 */
export var MXV = {
  code: 'MXV',
  base: 10,
  exponent: 2
};